// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_h2-0";
export var actionModalContentContainer = "_h2-1";
export var createTagButton = "_h2-2";
export var footerContainer = "_h2-7";
export var fullWidthDivider = "_h2-3";
export var hasCreateTagButton = "_h2-4";
export var noCreateTagButton = "_h2-5";
export var tagsContainer = "_h2-6";
export var tagsModalContentContainer = "_h2-8";